import { render, staticRenderFns } from "./TransactionRejectMessageView.vue?vue&type=template&id=0bc1b4bb&"
import script from "./TransactionRejectMessageView.vue?vue&type=script&lang=js&"
export * from "./TransactionRejectMessageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports